
/* eslint-disable no-unused-vars */
export function getIconSrc(name){
    switch (name){
        case 'room':
            return require(`./images/${name}.jpg`);
        default:
            return require(`./icon/${name}.png`);
    }
}